





































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { AuthModule } from '@/store/modules/auth.module'
import ErrorMessages from '@/components/ErrorMessages.vue'
import Input from '@/components/inputs/Input.vue'
import Password from '@/components/inputs/Password.vue'
import { NoCache } from '@/decorators/NoCache'
import WillowChatManager from '@/utils/WillowChatManager'
import Api from '@/api'
import { ChainModule } from '@/store/modules/chain.module'
import { EUserType, ITokenPayload } from '@zunta/configurations'
import MigrateToV2Popup from './components/MigrateToV2Popup.vue'

const jwtDecode = require('jwt-decode')

@Component({
  components: {
    Input,
    Password,
    ErrorMessages,
    MigrateToV2Popup,
  }
})
export default class LoginPage extends Vue {
  authModuleInstance: AuthModule = getModule(AuthModule, this.$store)
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)

  email: string = ''
  password: string = ''
  showMigrateToV2Popup = false

  get errors () {
    return this.$store.state.auth.errors
  }

  @NoCache
  get url () {
    const user = Api.getUser()
    let { nextUrl } = this.$route.query
    nextUrl = nextUrl ? decodeURI(nextUrl as string) : ''
    if (user && nextUrl) {
      if (nextUrl.indexOf('/app/admin') === 0) {
        return user.isAdmin() ? nextUrl : this.defaultUrl
      }
      return user.isAdmin() || user.isDataEntry() ? this.defaultUrl : nextUrl
    }
    return this.defaultUrl
  }

  @NoCache
  get defaultUrl () {
    const user = Api.getUser()
    if (!user) {
      return null
    }

    if (user.isDataEntry()) {
      return { name: 'admin-uploads' }
    }
    if (user.userRole === 'Admin' && user.data.facilities && user.data.facilities.length === 0) {
      return { name: 'management-facilities-login' }
    }
    if (user.isManager()) {
      return { name: 'management-todo' }
    }
    if (user.isAdmin()) {
      return { name: 'admin-dashboard' }
    }
    if (user.isResident()) {
      return { name: 'resident-general' }
    }
  }

  async doLogin (): Promise<void> {
    const email = this.email.trim()
    const password = this.password.trim()

    if (email && password) {
      const responseToken = await this.authModuleInstance.login({ email, password })
      if (responseToken) {
        this.authModuleInstance.setToken(responseToken)
        const userData: ITokenPayload = jwtDecode(responseToken)
        const isCorrectUser = await this.authModuleInstance.getIsValidUser(userData)
        const canEnterChain = await this.chainModuleInstance.getCanEnterChain(userData)
        if (!isCorrectUser || !canEnterChain) {
          await Api.logout(true)
          this.$eventBus.$emit('notify', {
            color: 'var(--status-error-color)',
            message: isCorrectUser ? 'Chain is Deactivated' : 'User not properly set up',
            header: `Login`,
            icon: 'warning'
          })
          return
        }
        if (userData.migratedToV2) {
          if (userData.type === EUserType.CLIENT) {
            this.showMigrateToV2Popup = true
          } else if (userData.type === EUserType.RESIDENT) {
            return Api.v2.redirectResidentUserToV2()
          }
        } else {
          this.$router.push(this.url as any)
        }
        return this.loginToWillow()
      }
    }
  }

  loginToWillow (): void {
    const user = Api.getUser()
    if (user && !user.isResident()) {
      WillowChatManager.requestToLogin(user.data.id).catch(async () => {
        const data: any = user.data
        await WillowChatManager.createAccount({
          userId: data.id,
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email
        })
        WillowChatManager.requestToLogin(data.id)
      })
    }
  }
}
